import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import {
  User,
  Lock,
  Search,
  List,
  BarChart2,
  Grid,
  Globe,
  FileText,
  FileMinus,
  Edit,
  Trash2,
  Home,
  Briefcase,
  Plus,
  Users,
  Tool,
  Printer,
  Box,
  Eye,
  EyeOff,
  Filter,
  Phone,
  ArrowDown,
  ArrowLeft,
  ArrowUp,
  LogOut,
  X,
  RotateCw,
  DownloadCloud,
  Layers,
  Square,
  Mail,
  Menu,
  Upload,
  ChevronLeft,
  ChevronRight,
  ChevronsDown,
  Check,
  CheckSquare,
  Link,
  CornerDownLeft,
  AlertTriangle,
  ArrowRight,
  AlertCircle,
  DollarSign,
  Codesandbox,
  Info,
  MapPin,
  Map,
  Cpu,
  AlertOctagon,
  ChevronDown,
  ChevronUp,
  ChevronsUp,
  ChevronsLeft,
  ChevronsRight,
  Move,
  Image,
  Octagon,
  ZoomIn,
  ZoomOut,
  Scissors,
  RefreshCcw,
  RotateCcw,
  Maximize2,
  Minimize2,
  CornerRightUp,
  CornerRightDown,
  Save,
  Play,
} from 'angular-feather/icons';
import { TopBarComponent } from './top-bar/top-bar.component';
import { SearchSortComponent } from './search-sort/search-sort.component';
import { GridViewComponent } from './grid-view/grid-view.component';
import { ListViewComponent } from './list-view/list-view.component';
import { ImageGalleryComponent } from './image-gallery/image-gallery.component';
import { LoaderComponent } from './loader/loader.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginatorComponent } from './paginator/paginator.component';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { DocumentsComponent } from './documents/documents.component';
import { UploadFloorComponent } from './upload-floor/upload-floor.component';
import { EditMaterialsComponent } from './edit-materials/edit-materials.component';
import { EditMaterialModalComponent } from './edit-material-modal/edit-material-modal.component';
import { FpDocumentsComponent } from './fp-documents/fp-documents.component';
import { ExtraCostTabComponent } from './extra-cost-tab/extra-cost-tab.component';
import { PercentageTabComponent } from './percentage-tab/percentage-tab.component';
import { AlertPopoverComponent } from './alert-popover/alert-popover.component';
import { LinkUnlinkComponent } from './link-unlink/link-unlink.component';
import { FirePartitionInfoComponent } from './fire-partition-info/fire-partition-info.component';
import { AddFpAlertComponent } from './add-fp-alert/add-fp-alert.component';
import { AllMaterialsTabComponent } from './all-materials-tab/all-materials-tab.component';
import { AlertBreachComponent } from './alert-breach/alert-breach.component';
import { AlertLinkUnlinkComponent } from './alert-link-unlink/alert-link-unlink.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MapReplacementOperationComponent } from './map-replacement-operation/map-replacement-operation.component';
import { PreviewNewMapComponent } from './preview-new-map/preview-new-map.component';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { NgSelectModule } from '@ng-select/ng-select';
import {BsDatepickerModule, BsLocaleService} from "ngx-bootstrap/datepicker";
import {defineLocale, nlLocale} from "ngx-bootstrap/chronos";
const icons = {
  User,
  Lock,
  Search,
  List,
  BarChart2,
  Grid,
  Globe,
  FileText,
  FileMinus,
  Edit,
  Trash2,
  Home,
  Briefcase,
  Plus,
  Users,
  Tool,
  Printer,
  Box,
  Eye,
  EyeOff,
  Filter,
  RotateCcw,
  Phone,
  LogOut,
  X,
  RotateCw,
  DownloadCloud,
  Layers,
  Square,
  Mail,
  Menu,
  Upload,
  ChevronLeft,
  ChevronRight,
  ChevronsUp,
  ChevronsDown,
  ChevronsLeft,
  Check,
  CheckSquare,
  Link,
  CornerDownLeft,
  AlertTriangle,
  ArrowRight,
  ArrowDown,
  ArrowLeft,
  ArrowUp,
  AlertCircle,
  DollarSign,
  Codesandbox,
  Info,
  MapPin,
  Map,
  Cpu,
  RefreshCcw,
  AlertOctagon,
  ChevronDown,
  ChevronUp,
  Move,
  Image,
  Octagon,
  ChevronsRight,
  ZoomIn,
  ZoomOut,
  Scissors,
  Maximize2,
  Minimize2,
  CornerRightUp,
  CornerRightDown,
  Save,
  Play
};

@NgModule({
  declarations: [
    TopBarComponent,
    SearchSortComponent,
    GridViewComponent,
    ListViewComponent,
    ImageGalleryComponent,
    LoaderComponent,
    PaginatorComponent,
    UploadModalComponent,
    UploadFloorComponent,
    DocumentsComponent,
    EditMaterialsComponent,
    EditMaterialModalComponent,
    FpDocumentsComponent,
    AlertPopoverComponent,
    LinkUnlinkComponent,
    FirePartitionInfoComponent,
    ExtraCostTabComponent,
    AllMaterialsTabComponent,
    PercentageTabComponent,
    AlertLinkUnlinkComponent,
    AlertBreachComponent,
    AddFpAlertComponent,
    MapReplacementOperationComponent,
    PreviewNewMapComponent,
  ],
  imports: [
    CommonModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    FormsModule,
    LeafletModule,
    NgMultiSelectDropDownModule.forRoot(),
    FeatherModule.pick(icons),
    NgSelectModule,
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    FeatherModule,
    TopBarComponent,
    SearchSortComponent,
    GridViewComponent,
    ListViewComponent,
    ImageGalleryComponent,
    EditMaterialsComponent,
    FpDocumentsComponent,
    ExtraCostTabComponent,
    AllMaterialsTabComponent,
    PercentageTabComponent,
    LoaderComponent,
    PaginatorComponent,
    UploadModalComponent,
    DocumentsComponent,
    UploadFloorComponent,
    AlertPopoverComponent,
    LinkUnlinkComponent,
    FirePartitionInfoComponent,
    AlertBreachComponent,
    AlertLinkUnlinkComponent,
    AddFpAlertComponent,
    MapReplacementOperationComponent,
    PreviewNewMapComponent,
    BsDatepickerModule,
  ],
})
export class UiModule {
  constructor(localeService: BsLocaleService) {
    defineLocale('nl', nlLocale);
    localeService.use('nl');
  }
}
